import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {QueryClient, QueryClientProvider} from 'react-query';
import App from './App';
import {AuthProvider} from "./authentication/AuthContext";
import {initializeTheme} from "./theme/theme";

const queryClient = new QueryClient();
initializeTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <QueryClientProvider client={queryClient}>
        <React.StrictMode>
            <AuthProvider>
                <App/>
            </AuthProvider>
        </React.StrictMode>
    </QueryClientProvider>,
);
